import { Button, Form, Popover, Tooltip } from "antd";
import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import { Rule } from "antd/lib/form";

function EditablePopover({
  message,
  placeholder,
  disable = false,
  onSubmit,
  rules = [],
  placeholderForEmptyMessage = "No Milestone Action added"
}: {
  message: string;
  placeholder?: string;
  disable?: boolean;
  onSubmit: (result: any) => void;
  rules?: Array<Rule>;
  placeholderForEmptyMessage?: string;
}) {
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const [inputData, setInputData] = useState(message);

  useEffect(() => {
    setInputData(message);
  }, [message, open]);

  const contentForm = useMemo(() => {
    return open ? (
      <Form
        layout="vertical"
        className="w-80 m-0 p-0"
        onFinish={() => {
          if (onSubmit) onSubmit(inputData || "");
          hide();
        }}
        validateTrigger="onChange"
      >
        <Form.Item name="name" rules={rules} initialValue={inputData}>
          <textarea
            rows={5}
            value={inputData}
            placeholder={placeholder}
            onChange={(event) => {
              setInputData(event.target.value || "");
            }}
            className="grow w-full"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        </Form.Item>

        <div className="w-full my-1 px-1 space-x-2 flex justify-end">
          <Button
            className="w-24"
            onClick={hide}
            data-testid="index-button-cancel"
          >
            Cancel
          </Button>
          <Button
            className="w-24"
            type="primary"
            htmlType="submit"
            data-testid="index-button-save"
          >
            Save
          </Button>
        </div>
      </Form>
    ) : (
      <div />
    );
  }, [inputData, onSubmit, open, placeholder, rules]);

  return (
    <Popover
      content={
        disable ? (
          <div className="w-80 m-0 p-0">
            {message || (
              <div className="text-gray-500 text-center">
                {placeholderForEmptyMessage || "N/A"}
              </div>
            )}
          </div>
        ) : (
          contentForm
        )
      }
      title={null}
      className="p-0 m-0"
      trigger={disable ? "hover" : "click"}
      open={open}
      onOpenChange={handleOpenChange}
    >
      {disable ? (
        <InfoCircleOutlined className="text-ciq-gray-950 hover:bg-black/5" />
      ) : (
        <div className="flex items-center space-x-1 cursor-pointer">
          <Tooltip title={inputData} open={open ? false : undefined}>
            <span className="flex items-center space-x-1 hover:bg-black/5">
              <InfoCircleOutlined className="text-sm text-ciq-gray-950" />
              <EditOutlined className="text-sm text-ciq-primary-900" />
            </span>
          </Tooltip>
        </div>
      )}
    </Popover>
  );
}

export default EditablePopover;
